import React, { useState, useEffect } from 'react';
import Modal from 'react-bootstrap/Modal';
import { useTranslation } from 'react-i18next';
import { AppConfigService } from '@aperza/util';
import style from './CatalogPartner.module.scss';
const CatalogPartnerModal = (props) => {
    let env = AppConfigService.getEnvironment();
    let { documentId, show = false, onCloseHandler } = props;
    const [height, setHeight] = useState(610);
    const { t } = useTranslation(['catalog']);
    const onIframeLoad = () => {
        //find the height of the internal page
        // var the_height = document.getElementById('iframe').contentWindow.document.body.scrollHeight;
        //change the height of the iframe
        // document.getElementById('iframe').height = the_height;
    };
    useEffect(() => {
        window.addEventListener('message', onMessage, false);
    }, []);
    useEffect(() => { }, [height]);
    const onMessage = (event) => {
        if (event) {
            if (event.origin.includes('//dx.')) {
                try {
                    let eventData = event.data;
                    if (eventData.event === 'loadedContentHeight') {
                        setHeight(eventData.height);
                    }
                }
                catch (e) {
                    console.log('error parsing onMessage: ', e);
                }
            }
        }
    };
    return (React.createElement(Modal, { show: show, onHide: onCloseHandler, className: "modal-catalog-preview fade", dialogClassName: style.CatalogPreviewModal, size: 'lg', centered: true },
        React.createElement(Modal.Header, { closeButton: true },
            React.createElement(Modal.Title, null, t('catalog.partner.modalTitle'))),
        React.createElement(Modal.Body, { className: "p-0" },
            React.createElement("iframe", { id: "partner-iframe", src: AppConfigService.getCloudPartnerHost(env) + '/apply/new/' + documentId, frameBorder: "0", width: "100%", height: height })),
        React.createElement(Modal.Footer, null,
            React.createElement("button", { type: "button", onClick: onCloseHandler, className: "btn btn-default btn-wide btn-xl", "data-dismiss": "modal", "aria-label": "Close" }, t('close')))));
};
CatalogPartnerModal.displayName = 'CatalogPartnerModal';
export default CatalogPartnerModal;
